export default __webpack_public_path__ + "static/media/settingsPageLogo.c831e6c0.png";